import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

export default {
    createUser: httpsCallable(functions, "createUserFunc"),
    postPoll: httpsCallable(functions, "postPollFunc"),
    getUserPolls: httpsCallable(functions, "getUserPollsFunc"),
    vote: httpsCallable(functions, "voteFunc"),
    getUser: httpsCallable(functions, "getUserFunc"),
    followUser: httpsCallable(functions, "followUserFunc"),
    unfollowUser: httpsCallable(functions, "unfollowUserFunc"),
    createSubscription: httpsCallable(functions, "paymentIntentFunc"),
    getAnalytics: httpsCallable(functions, "getAnalyticsFunc")
}